import { get, isString } from 'lodash';
import { RequestContext } from '@fiverr-private/perseus';
import { getContext } from '@fiverr-private/fiverr_context';
import {
    injectParamsToField as originalInjectParamsToField,
    injectParamsToObject as originalInjectParamsToObject,
    DYNAMIC_PARAMS_REGEX,
} from './utils';

const injectParamsToFieldClient = (field) => {
    if (!isString(field)) {
        return field;
    }

    const regex = new RegExp(DYNAMIC_PARAMS_REGEX, 'g');
    return field?.replace(regex, (match, p1) => get(getContext(), p1));
};

/** Client-side implementation */
export { injectParamsToFieldClient as injectParamsToField };

/** NodeJS-only implementation */
export const injectParamsToFieldNode = originalInjectParamsToField.bind(null, RequestContext);
export const injectParamsToObject = originalInjectParamsToObject.bind(null, RequestContext);
